var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newBreadcrumb"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/medium' }}},[_vm._v("新闻资讯")]),_c('el-breadcrumb-item',[_vm._v("新闻详情")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }